var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { MS_ADAPTER_ENDPOINTS } from "../../../../utils/endpoints";
const ManagerMsLoginInit = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [error, setError] = useState(null);
    useEffect(() => {
        const initiateLogin = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e;
            try {
                // Always use window.location.origin as tenantUrl
                const tenantUrl = window.location.origin;
                // Call API to get login URL
                const response = yield axios.get(MS_ADAPTER_ENDPOINTS.GET_LOGIN_URL, {
                    params: {
                        tenantUrl: tenantUrl + "/manager-ms-login-callback",
                    },
                });
                if (((_a = response.data) === null || _a === void 0 ? void 0 : _a.status) === 200 && ((_c = (_b = response.data) === null || _b === void 0 ? void 0 : _b.result) === null || _c === void 0 ? void 0 : _c.loginUrl)) {
                    // Store tenantUrl in sessionStorage for later use in callback
                    sessionStorage.setItem("manager_ms_tenant_url", tenantUrl);
                    // Store encrypted link parameter for later use in callback
                    const linkParam = searchParams.get("link");
                    if (linkParam) {
                        sessionStorage.setItem("manager_meeting_link_param", linkParam);
                    }
                    // Redirect to Microsoft login URL
                    window.location.href = response.data.result.loginUrl;
                }
                else {
                    setError("Failed to get login URL");
                }
            }
            catch (err) {
                console.error("Error initiating MS login:", err);
                setError(((_e = (_d = err === null || err === void 0 ? void 0 : err.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.message) || "Failed to initiate login");
            }
        });
        initiateLogin();
    }, [searchParams]);
    const spinnerIndicator = (_jsx(LoadingOutlined, { style: { fontSize: 48, color: "#1890ff" }, spin: true }));
    if (error) {
        return (_jsxs("div", Object.assign({ style: {
                width: "100vw",
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
            } }, { children: [_jsx("div", Object.assign({ style: { color: "red", marginBottom: 16 } }, { children: error })), _jsx("button", Object.assign({ onClick: () => navigate(-1) }, { children: "Go Back" }))] })));
    }
    return (_jsxs("div", Object.assign({ style: {
            width: "100vw",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
        } }, { children: [_jsx(Spin, { size: "large", indicator: spinnerIndicator }), _jsx("div", Object.assign({ style: { marginTop: 16 } }, { children: "Redirecting to Microsoft login..." }))] })));
};
export default ManagerMsLoginInit;
